import React from 'react';
import * as Ink from '@carta/ink';

/**
 * Renders a section divider line
 */
const SideNavDivider = () => {
  return (
    <Ink.Box vertical="12px" horizontal="20px">
      <Ink.Divider />
    </Ink.Box>
  );
};

SideNavDivider.displayName = 'SideNav.Divider';

export default SideNavDivider;
